const DashboardAutoRefreshInterval = Object.freeze({
  OFF: 'OFF',
  ONE_MIN: 'ONE_MIN',
  TWO_MIN: 'TWO_MIN',
  FIVE_MIN: 'FIVE_MIN',
  TEN_MIN: 'TEN_MIN'
})
export default DashboardAutoRefreshInterval
// RESERVE BELOW
export type DashboardAutoRefreshIntervalString = typeof DashboardAutoRefreshInterval[keyof typeof DashboardAutoRefreshInterval]
